import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import UserCanConfirmAdjustmentsModal from '../user-can-confirm-adjustments-modal/UserCanConfirmAdjustmentsModal'
import {
  ClientProposalOutputDto,
  NonCompliantRulesFragment,
} from '../../../../../../../lib/graphql'
import { errorToast } from '../../../../../../../utils'
import { IProposalInteractionsProps } from '../../../../Proposal'
import PingPongButton from '../../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../../utils/ping-pong-button-type.enum.ts'

interface IUserCanConfirmAdjustmentsFooterProps {
  userActions: IProposalInteractionsProps['userActions']
  clientProposal: NonCompliantRulesFragment &
    Pick<ClientProposalOutputDto, '_id'>
}

const UserCanConfirmAdjustmentsFooter = ({
  userActions,
  clientProposal,
}: IUserCanConfirmAdjustmentsFooterProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false)

  const userConfirmedAdjustments = userActions?.userConfirmedAdjustments

  if (!userConfirmedAdjustments) {
    return null
  }

  const onSubmit = async () => {
    try {
      await userConfirmedAdjustments.callback({
        clientProposalId: clientProposal._id,
      })
      setIsOpenModal(false)
    } catch {
      errorToast(['Impossible de confirmer les ajustements'])
    }
  }

  return (
    <div className='flex w-full flex-col gap-3 py-5'>
      <PingPongButton
        type={PingPongButtonTypeEnum.PAYMENT_DONE}
        label={
          <FormattedMessage
            id='ui.UserCanConfirmAdjustmentsFooter.depositPaid'
            defaultMessage='Acompte réglé'
          />
        }
      />

      <PingPongButton
        type={PingPongButtonTypeEnum.CONFIRM}
        label={
          <FormattedMessage
            id='ui.UserCanConfirmAdjustmentsFooter.confirmAdjustments'
            defaultMessage='Confirmer les ajustements'
          />
        }
        onClick={() => setIsOpenModal(true)}
      />

      {isOpenModal && (
        <UserCanConfirmAdjustmentsModal
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
          onSubmit={onSubmit}
          isLoadingSubmit={userConfirmedAdjustments.isLoading}
        />
      )}
    </div>
  )
}

export default UserCanConfirmAdjustmentsFooter
